module.exports = __webpack_public_path__ + "img/logistics.png";